import { InvitationMessage, InvitationMessageType } from '@playcastdotio/Messaging';
import { setInvitation } from '../../managers/invitation';
import { invitationStateV2 } from '../../../stores/shared';

export const handleInvitationMessage = (message: InvitationMessage) => {
  console.log('Invitation message:', message);
  switch (message.type) {
    case InvitationMessageType.INVITATION_STORE_ERROR: {
      console.log('Invitation store error:', message);
      break;
    }
    case InvitationMessageType.INVITATION_STORE_SUCCESS: {
      console.log('Invitation store success:', message);
      // setInvitation(message.updatedInvitation, false);
      invitationStateV2.updateState(message.updatedInvitation);
      break;
    }
    case InvitationMessageType.INVITATION_STORE:
    case InvitationMessageType.INVITATION_ALIAS_CHANGED:
    case InvitationMessageType.INVITATION_IS_ALIAS:
    case InvitationMessageType.INVITATION_JOIN:
    case InvitationMessageType.INVITATION_JOIN_ERROR:
    case InvitationMessageType.INVITATION_JOIN_SUCCESS:
    case InvitationMessageType.INVITATION_QUERY:
    case InvitationMessageType.INVITATION_QUERY_RESPONSE: {
      // Unwanted messages
      console.log('Unwanted invitation message:', message);
      break;
    }
  }
};
